export default function handleEntryEdit(ngDialog) {
  'ngInject';

  function fromCamelToKebab(entry) {
    return entry.replace(/(?!^)([A-Z])/g, ($1) => '-' + $1.toLowerCase()).toLowerCase();
  }

  return function(mysolvrEntry) {
    const entryType = fromCamelToKebab(mysolvrEntry.type);
    const template = `<edit-${entryType}-modal class="base-modal base-modal--edit-${entryType}"
                                           mysolvr-entry="$ctrl.mysolvrEntry"
                                           confirm="confirm(value)"
                                           close-modal="closeThisDialog(value)">
                      </edit-${entryType}-modal>`;
    return ngDialog
      .openConfirm({
        template,
        controller: function() {
          this.mysolvrEntry = mysolvrEntry;
        },
        controllerAs: '$ctrl',
      })
      .then(submittedEntry => {
        if (submittedEntry.id) {
          return submittedEntry.$update();
        } else {
          return submittedEntry.$save();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/mysolvr-entries/util/handle-entry-edit.factory.js